import { app } from '../../app';

app.run(init);

/** @ngInject */
function init($rootScope) {
    $rootScope.saaspassFullExperienceTemplate = require('./saaspass-full-experience.html');
}



// WEBPACK FOOTER //
// ./src/portal/partials/saaspass-full-experience/saaspass-full-experience.js